/**
 * Contract §4 picks *One / *Other in the component.
 * i18next treats a numeric `count` option as a plural selector
 * (`needsPluralHandling` when count is not a string), so {{count}} is passed
 * as a string and the key is chosen here.
 */
export function tEc(t, key, vars) {
  if (!vars) return t(key);
  const options = { ...vars };
  if (options.count !== undefined && options.count !== null) {
    options.count = String(options.count);
  }
  return t(key, options);
}

export function countTotalKey(count) {
  return count === 1 ? 'ordersLayout.ecCountTotalOne' : 'ordersLayout.ecCountTotalOther';
}

export function subtotalKey(count) {
  return count === 1 ? 'ordersLayout.ecSubtotalOne' : 'ordersLayout.ecSubtotalOther';
}

export function productsKey(lineCount) {
  return lineCount === 1 ? 'ordersLayout.ecProductsOne' : 'ordersLayout.ecProductsOther';
}



// WEBPACK FOOTER //
// ./src/js/components/ordersLayout/ecText.js